module.exports = __webpack_public_path__ + "static/c28857ce10ea335f5af60e05ba5c864f18278daaace8e0c2f2375b3b9db8f982-22d489df774d9364dc7dd0fd42fd7f5a.png";